import { Injectable } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Injectable({
    providedIn: 'root',
})
export class IconService {
    public buildIconsObject<T extends string>(enumValues: T[], formControlValue: T | null): Record<string, IconProp> {
        return enumValues.reduce((acc: Record<string, IconProp>, currentIcon: T) => {
            const prefix = formControlValue === currentIcon ? 'fad' : 'fas';

            return {
                ...acc,
                [currentIcon]: [prefix, currentIcon] as IconProp,
            };
        }, {});
    }
}
